// extracted by mini-css-extract-plugin
module.exports = {"paragraphs":"AskBetaInfoModal_paragraphs__42Dby"};